import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'home',
      path: '/',
      component: () => import('../components/pages/Home.vue'),
      meta: {
        title: 'Rewarding Dog Training, LLC',
        description: 'Positive reinforcement dog training that is rewarding for humans and dogs! In person training in Boulder, Louisville, & Lafayette, CO. Virtual training options',
        robots: 'index, follow',
      },
    },
    {
      name: 'about',
      path: '/about',
      component: () => import('../components/pages/About.vue'),
      meta: {
        title: 'About - Rewarding Dog Training',
        description: 'Nadia Magallon, CPDT-KA, is passionate about using technology to help people learn better and have a positively rewarding experience for both humans and dogs.',
        robots: 'index, follow',
      },
    },
    {
      name: 'services',
      path: '/services',
      component: () => import('../components/pages/PageTemplate.vue'),
      children: [
        {
          name: 'all-services',
          path: '',
          component: () => import('../components/pages/Services.vue'),
          meta: {
            title: 'Services - Rewarding Dog Training',
            description: 'Private and virtual sessions to help with basic manners, reactivity, calmness, and more. Basic Manners package option. Group classes include Basic Manners, Reactive Rover, Outdoor Manners.',
            robots: 'index, follow',
          },
        },
        {
          name: 'separation-anxiety',
          path: 'separation-anxiety',
          component: () => import('../components/pages/PageTemplateComponent.vue'),
          children: [
            {
              name: 'separation-anxiety-public',
              path: '',
              component: () => import('../components/pages/SeparationAnxiety.vue'),
              meta: {
                title: 'Separation Anxiety - Rewarding Dog Training',
                description: 'Tackle your dog\'s separation anxiety with our hands on coaching, do it yourself program, or a hybrid model',
                robots: 'index, follow',
              },
            },
            {
              name: 'separation-anxiety-exercise',
              path: 'separation-anxiety-exercise',
              component: () => import('../components/pages/SeparationAnxietyExercise.vue'),
              meta: {
                title: 'Separation Anxiety Exercise - Rewarding Dog Training',
                description: 'Separation Anxiety Exercise - Rewarding Dog Training',
                robots: 'noindex, nofollow',
              },
            },
          ],
        },
      ],
    },
    {
      name: 'separation-anxiety-exercise-public',
      path: '/separation-anxiety-exercise',
      component: () => import('../components/pages/SeparationAnxietyExercise.vue'),
      meta: {
        title: 'Separation Anxiety Exercise - Rewarding Dog Training',
        description: 'Separation Anxiety Exercise - Rewarding Dog Training',
        robots: 'noindex, nofollow',
      },
    },
    {
      name: 'group-class',
      path: '/services/group-class',
      component: () => import('../components/pages/PageTemplate.vue'),
      children: [
        {
          name: 'all-group-classes',
          path: '',
          component: () => import('../components/pages/GroupClasses.vue'),
          meta: {
            title: 'Group Classes - Rewarding Dog Training',
            description: 'Group classes are a great option to train on a budget. Join our many class options to help strengthen your dog\'s attention and bond to you.',
            robots: 'index, follow',
          },
        },
        {
          name: 'basic-manners',
          path: 'basic-manners',
          component: () => import('../components/pages/BasicManners.vue'),
          meta: {
            title: 'Basic Manners - Rewarding Dog Training',
            description: 'In this 6 week class, you will learn how to teach your dog skills for calm, polite behaviors inside the house and outside.',
            robots: 'index, follow',
          },
        },
        // {
        //   name: 'reactive-rover',
        //   path: 'reactive-rover',
        //   component: () => import('../components/pages/ReactiveRover.vue'),
        //   meta: {
        //     title: 'Reactive Rover - Rewarding Dog Training',
        //     description: 'In this 6 week class, you will learn how to teach your dog skills to better handle the unexpected world around them, leading to decreased anxiety and reactivity.',
        //     robots: 'index, follow',
        //   },
        // },
        {
          name: 'outside-manners',
          path: 'outside-manners',
          component: () => import('../components/pages/OutsideManners.vue'),
          meta: {
            title: 'Outside manners - Rewarding Dog Training',
            description: 'In this 4 week class, you will take your training to the next level by practicing your recall, leash walking, and leave it in real world situations.',
            robots: 'index, follow',
          },
        },
        {
          name: 'reactive-rover',
          path: 'reactive-rover',
          component: () => import('../components/pages/ReactiveRover.vue'),
          meta: {
            title: 'Reactive Rover - Rewarding Dog Training',
            description: 'In this 6 week class, you will learn how to teach your dog skills to better handle the unexpected world around them, leading to decreased anxiety and reactivity.',
            robots: 'index, follow',
          },
        },
      ],
    },
    {
      name: 'relaxation-protocol',
      path: '/relaxation-protocol',
      component: () => import('../components/pages/RelaxationProtocol.vue'),
      meta: {
        title: 'Relaxation Protocol - Rewarding Dog Training',
        description: 'Mobile-friendly version of Dr. Karen Overall\'s Protocol for Relaxation with checkboxes to track progress as you go through it.',
        robots: 'index, follow',
      },
    },
    {
      name: 'contact',
      path: '/contact',
      component: () => import('../components/pages/Contact.vue'),
      meta: {
        title: 'Contact - Rewarding Dog Training',
        description: 'Contact Rewarding Dog Training. Reach out to discuss your training goals or any questions you may have.',
        robots: 'index, follow',
      },
    },
    {
      name: 'quick-links',
      path: '/quick-links',
      component: () => import('../components/pages/QuickLinks.vue'),
      meta: {
        title: 'Quick Links - Rewarding Dog Training',
        description: 'Rewarding Dog Training quick links!',
        robots: 'noindex, nofollow',
      },
    },
    {
      name: 'terms-and-conditions',
      path: '/terms-and-conditions',
      component: () => import('../components/pages/TermsAndConditions.vue'),
      meta: {
        title: 'Terms and Conditions - Rewarding Dog Training',
        description: 'Rewarding Dog Training Terms and Conditions. Read me to get started with training!',
        robots: 'noindex, nofollow',
      },
    },
    {
      path: '',
      redirect: { name: 'home' },
    },
    {
      name: '404',
      path: '/404',
      component: () => import('../components/pages/404.vue'),
      meta: {
        title: '404 - Rewarding Dog Training',
        description: 'Uh oh. Page not found. Must not have used enough rewards in your training to end up here',
        robots: 'noindex, nofollow',
      },

    },
    // KEEP LAST
    {
      path: '*',
      redirect: { name: '404' },
    },
  ],
})
